import { useCallback, useEffect, useState } from "react";
import { getDropDownContact } from "../../services/customerStakeholder";

const useContactReason = () => {
  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    const res = await getDropDownContact();
    if (res.data.code === "0000") {
      const { objectValue } = res.data;
      setData(objectValue);
    }
  }, [setData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return [data];
};

export default useContactReason;
